import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { updateOrganization } from '../organization';
import styles from './index.module.css';

type User = {
  id: number;
  name: string;
  display_name: string;
  email: string;
};

type Props = {
  orgId: number;
  defaultMembers: number[];
  users: User[];
  shouldSave: boolean;
  setShouldSave: (shouldSave: boolean) => void;
};

export const DefaultMembers: React.FC<Props> = ({
  orgId,
  defaultMembers,
  users,
  shouldSave,
  setShouldSave
}) => {
  const [selectedMemberIds, setSelectedMemberIds] = useState<number[]>(
    Array.isArray(defaultMembers) ? defaultMembers : []
  );

  useEffect(() => {
    if (shouldSave) {
      updateOrganization({
        organizationId: orgId,
        body: { defaultMembers: selectedMemberIds.map(String) },
        showSuccess: false
      });
      setShouldSave(false);
    }
  }, [shouldSave]);

  const options = users.map(user => ({
    value: user.id,
    label: `${user.display_name || user.name} (${user.email})`
  }));

  const matchesSearch = (input: string, user: User) => {
    const search = input.toLowerCase();
    return [user.display_name, user.name, user.email].some(field =>
      (field ?? '').toLowerCase().includes(search)
    );
  };

  return (
    <div>
      <h3>Default Members</h3>
      <Select
        mode="multiple"
        allowClear
        showSearch
        className={styles.select}
        options={options}
        value={selectedMemberIds}
        onChange={setSelectedMemberIds}
        placeholder="Select members"
        filterOption={(input, option) => {
          const user = users.find(({ id }) => id === option?.value);
          return user ? matchesSearch(input, user) : false;
        }}
      />
    </div>
  );
};
